export * from './lib/truncate.pipe.module';

export { TruncatePipe } from './lib/truncate.pipe';
